export default {
      id: "map-usage",
      viewBox: "0 0 14 18",
      url: __webpack_public_path__ + "img/icons.479460d5.svg#map",
      toString: function () {
        return this.url;
      }
    }